import React, { useEffect, useState } from 'react';
import { Button, Divider, Tag, Spin, Collapse, Pagination } from 'antd';
import { genericApiCall } from './CommonApiCallCalender';
import moment from 'moment';
import {
  DeleteOutlined, EditOutlined, EyeOutlined,
  ExclamationCircleOutlined,
  MedicineBoxOutlined, HeartOutlined, BankOutlined, PlusOutlined,
  HolderOutlined,
  VideoCameraOutlined, ExperimentOutlined, SafetyOutlined, TeamOutlined,
  UserOutlined, GlobalOutlined, CalendarOutlined, ClockCircleOutlined,
  PhoneOutlined, FileTextOutlined, StarOutlined, SmileOutlined,
  CompassOutlined, CustomerServiceOutlined, ReconciliationOutlined,
  CrownOutlined, ThunderboltOutlined, TrophyOutlined,
  SecurityScanOutlined, AuditOutlined, AlertOutlined, LikeOutlined,
  AppstoreOutlined, SearchOutlined, CloseOutlined,
  SkinOutlined, ZoomInOutlined, WomanOutlined, ManOutlined,
  FireOutlined, BulbOutlined, ApartmentOutlined,
  SafetyCertificateOutlined, ShareAltOutlined,
  AudioOutlined, EnvironmentOutlined, IdcardOutlined, DashboardOutlined,
  CoffeeOutlined, RestOutlined, BugOutlined, ScissorOutlined,
  PlusSquareOutlined, HomeOutlined, ShopOutlined, LineChartOutlined, AimOutlined,
  PoweroffOutlined,
} from '@ant-design/icons';

const ICON_MAP = {
  DeleteOutlined: <DeleteOutlined />,
  EditOutlined: <EditOutlined />,
  EyeOutlined: <EyeOutlined />,
  ExclamationCircleOutlined: <ExclamationCircleOutlined />,
  MedicineBoxOutlined: <MedicineBoxOutlined />,
  HeartOutlined: <HeartOutlined />,
  BankOutlined: <BankOutlined />,
  PlusOutlined: <PlusOutlined />,
  HolderOutlined: <HolderOutlined />,
  VideoCameraOutlined: <VideoCameraOutlined />,
  ExperimentOutlined: <ExperimentOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  TeamOutlined: <TeamOutlined />,
  UserOutlined: <UserOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  PhoneOutlined: <PhoneOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  StarOutlined: <StarOutlined />,
  SmileOutlined: <SmileOutlined />,
  CompassOutlined: <CompassOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  ReconciliationOutlined: <ReconciliationOutlined />,
  CrownOutlined: <CrownOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  AuditOutlined: <AuditOutlined />,
  AlertOutlined: <AlertOutlined />,
  LikeOutlined: <LikeOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  SearchOutlined: <SearchOutlined />,
  CloseOutlined: <CloseOutlined />,
  SkinOutlined: <SkinOutlined />,
  ZoomInOutlined: <ZoomInOutlined />,
  WomanOutlined: <WomanOutlined />,
  ManOutlined: <ManOutlined />,
  FireOutlined: <FireOutlined />,
  BulbOutlined: <BulbOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  ShareAltOutlined: <ShareAltOutlined />,
  AudioOutlined: <AudioOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  CoffeeOutlined: <CoffeeOutlined />,
  RestOutlined: <RestOutlined />,
  BugOutlined: <BugOutlined />,
  ScissorOutlined: <ScissorOutlined />,
  PlusSquareOutlined: <PlusSquareOutlined />,
  HomeOutlined: <HomeOutlined />,
  ShopOutlined: <ShopOutlined />,
  LineChartOutlined: <LineChartOutlined />,
  AimOutlined: <AimOutlined />,
  PoweroffOutlined: <PoweroffOutlined />
};

const getCategoryIcon = (category) => {
  let iconStr = 'AppstoreOutlined';
  try {
    const stored = JSON.parse(localStorage.getItem('showCategory') || '{}');
    const categories = Array.isArray(stored) ? stored : Object.values(stored);

    const categoryObj = categories.find(c => {
      if (!c) return false;
      // Match by product_category_id (or id if stored that way)
      const storedId = c.product_category_id || c.id;
      const targetId = category.product_category_id || category.id;
      return storedId && targetId && storedId === targetId;
    });

    if (categoryObj && categoryObj.icon_name) {
      iconStr = categoryObj.icon_name;
    } else if (categoryObj && categoryObj.icon) {
      // Fallback just in case some are stored as 'icon'
      iconStr = categoryObj.icon;
    }
  } catch (e) {
    console.error('Error parsing showCategory', e);
  }

  if (ICON_MAP[iconStr]) {
    return React.cloneElement(ICON_MAP[iconStr], { style: { marginRight: 8, color: '#008385', fontSize: 16 } });
  }

  return <AppstoreOutlined style={{ marginRight: 8, color: '#008385', fontSize: 16 }} />;
};

const { Panel } = Collapse;

const LantumProductAvailability = ({ onClose, eventData }) => {
  const [loading, setLoading] = useState(true);
  const [metadata, setMetadata] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (eventData) {
      const fetchMetadata = async () => {
        try {
          setLoading(true);
          const roomId = eventData.room_id || eventData.resourceId;
          const date = eventData.lantum_start_time
            ? moment(eventData.lantum_start_time).format('YYYY-MM-DD')
            : (eventData.date ? moment(eventData.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));

          // Try to extract clinician IDs from the array
          const clinicianIds = eventData.clinicians?.map(c => c.clinician_id || c.id) || [];

          if (!roomId || clinicianIds.length === 0) {
            setLoading(false);
            return;
          }

          const payload = {
            room_id: roomId,
            date: date,
            clinicians: clinicianIds
          };

          const response = await genericApiCall("csr-rooms/clinician-metadata", payload);
          if (response?.data?.success) {
            setMetadata(response.data.data || []);
          } else {
            setError(response?.data?.message || "Failed to fetch metadata.");
          }
        } catch (err) {
          setError("An error occurred while fetching data.");
        } finally {
          setLoading(false);
        }
      };
      fetchMetadata();
    } else {
      setLoading(false);
    }
  }, [eventData]);

  const handlePageChange = async (page, clinicianId, categoryId) => {
    try {
      const roomId = eventData.room_id || eventData.resourceId;
      const date = eventData.lantum_start_time
        ? moment(eventData.lantum_start_time).format('YYYY-MM-DD')
        : (eventData.date ? moment(eventData.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));

      const payload = {
        room_id: roomId,
        date: date,
        clinicians: [clinicianId]
      };

      const response = await genericApiCall(`csr-rooms/clinician-metadata?page=${page}&product_category_id=${categoryId}`, payload);

      if (response?.data?.success) {
        const updatedClinicianData = response.data.data.find(c => c.clinician_id === clinicianId || c.id === clinicianId);
        if (updatedClinicianData) {
          const updatedCategoryData = updatedClinicianData.product_categories?.find(c => c.product_category_id === categoryId || c.id === categoryId);

          if (updatedCategoryData) {
            setMetadata(prev => prev.map(c => {
              if (c.clinician_id === clinicianId || c.id === clinicianId) {
                return {
                  ...c,
                  product_categories: c.product_categories.map(cat => {
                    if (cat.product_category_id === categoryId || cat.id === categoryId) {
                      return {
                        ...cat,
                        non_gp_products: updatedCategoryData.non_gp_products
                      };
                    }
                    return cat;
                  })
                };
              }
              return c;
            }));
          }
        }
      }
    } catch (err) {
      console.error("Failed to fetch next page", err);
    }
  };

  const parseRule = (rules) => {
    if (!rules) return null;
    const mode = rules.day_schedule_mode;

    const renderLabel = (icon, text) => (
      <span style={{ fontWeight: 600, color: '#008385', marginRight: 6, display: 'inline-flex', alignItems: 'center' }}>
        {icon} <span style={{ marginLeft: 4 }}>{text}</span>
      </span>
    );

    const renderTimeBadge = (timeText) => (
      <span style={{
        color: '#006666',
        background: '#e6f5f5',
        padding: '2px 6px',
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 600
      }}>
        {timeText}
      </span>
    );

    const renderDayTime = (label, times, isLast) => (
      <span key={label} style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontWeight: 600, color: '#444' }}>{label}</span>
        <span style={{ margin: '0 4px', color: '#888' }}>:</span>
        {times}
        {!isLast && <span style={{ margin: '0 8px', color: '#ddd' }}>|</span>}
      </span>
    );

    if (mode === 'all') {
      const times = (rules.all_days_times || []).map(t => t.is_whole_day ? 'Whole day' : `${t.start_time} - ${t.end_time}`).join(', ');
      return (
        <div style={{ fontSize: 12, marginTop: 8, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          {renderLabel(<ClockCircleOutlined />, "All Days:")}
          {renderTimeBadge(times)}
        </div>
      );
    }

    if (mode === 'custom') {
      const days = rules.custom_days_selected || [];
      const daysContent = days.map((day, idx) => {
        const timesObj = rules.custom_days_times?.[day] || [];
        const timesText = timesObj.map(t => t.is_whole_day ? 'Whole day' : `${t.start_time} - ${t.end_time}`).join(', ');
        const dayLabel = day.charAt(0).toUpperCase() + day.slice(1);
        return renderDayTime(dayLabel, renderTimeBadge(timesText), idx === days.length - 1);
      });

      const extraDates = rules.custom_days_extra_dates_selected || [];
      const extraDatesContent = extraDates.map((date, idx) => {
        const timesObj = rules.custom_days_extra_dates?.[date] || [];
        const timesText = timesObj.map(t => t.is_whole_day ? 'Whole day' : `${t.start_time} - ${t.end_time}`).join(', ');
        return renderDayTime(date, renderTimeBadge(timesText), idx === extraDates.length - 1);
      });

      return (
        <div style={{ fontSize: 12, marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {days.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              {renderLabel(<ClockCircleOutlined />, "Days:")}
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>{daysContent}</div>
            </div>
          )}
          {extraDates.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              {renderLabel(<CalendarOutlined />, "Extra Dates:")}
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>{extraDatesContent}</div>
            </div>
          )}
        </div>
      );
    }

    if (mode === 'dates') {
      const dates = rules.specific_dates_selected || [];
      const datesContent = dates.map((date, idx) => {
        const timesObj = rules.specific_dates_times?.[date] || [];
        const timesText = timesObj.map(t => t.is_whole_day ? 'Whole day' : `${t.start_time} - ${t.end_time}`).join(', ');
        return renderDayTime(date, renderTimeBadge(timesText), idx === dates.length - 1);
      });

      return (
        <div style={{ fontSize: 12, marginTop: 8, display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          {renderLabel(<CalendarOutlined />, "Dates:")}
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>{datesContent}</div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="custom-scrollbar" style={{ padding: '0px 10px 10px', maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden' }}>
      {/* Section header */}
      <div
        style={{
          marginBottom: 12,
          textAlign: 'left',
          background: '#f4fbfb',
          border: '1px solid #d0ecec',
          borderRadius: 10,
          padding: '14px 16px',
        }}
      >
        <span
          style={{
            fontWeight: 700,
            fontSize: 14,
            color: '#008385',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <CalendarOutlined /> Clinician Product Availability {eventData?.room_name ? `${eventData.room_name}` : ''}
        </span>
        <span
          style={{
            fontSize: 12,
            color: '#888',
            display: 'block',
            marginTop: 2,
            textAlign: 'left',
          }}
        >
          View-only product availability details for this Clinician schedule.
        </span>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '30px 0' }}>
          <Spin tip="Loading clinician metadata..." className="custom-spinner" />
        </div>
      ) : error ? (
        <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
          {error}
        </div>
      ) : metadata.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          No metadata available for this event.
        </div>
      ) : (
        <Collapse
          accordion
          defaultActiveKey={['0']}
          style={{ background: 'transparent', border: 'none' }}
          className="clinician-collapse"
        >
          {metadata.map((clinician, index) => (
            <Panel
              key={index.toString()}
              style={{
                marginBottom: 16,
                background: 'transparent',
                border: 'none',
              }}
              header={
                <div style={{ display: 'flex', alignItems: 'center', fontWeight: 600, color: '#333', fontSize: 15, flexWrap: 'wrap', gap: '8px' }}>
                  <div>
                    <UserOutlined style={{ marginRight: 8, color: '#008385' }} />
                    {clinician.name} {clinician.surname} ({clinician.clinician_type})
                  </div>
                  {clinician.gender && (
                    <Tag color="cyan" style={{ borderRadius: 10, margin: 0, display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {clinician.gender.toLowerCase() === 'female' ? <WomanOutlined /> : clinician.gender.toLowerCase() === 'male' ? <ManOutlined /> : null}
                      {clinician.gender}
                    </Tag>
                  )}
                  {clinician.start_date && clinician.end_date && (
                    <div style={{ fontSize: 13, color: '#006666', background: '#e6f5f5', padding: '2px 8px', borderRadius: 4, display: 'flex', alignItems: 'center' }}>
                      <ClockCircleOutlined style={{ marginRight: 4 }} />
                      {moment.utc(clinician.start_date).format('HH:mm')} - {moment.utc(clinician.end_date).format('HH:mm')}
                    </div>
                  )}
                </div>
              }
            >
              <div style={{ padding: '0px 4px' }}>
                {/* GP Categories (Rendered without collapse) */}
                {clinician.product_categories?.filter((category) => category.type === 'gp').map((category, catIdx) => (
                  <div
                    key={`gp-${catIdx}`}
                    style={{
                      marginBottom: 12,
                      border: '1px solid #c8e6e6',
                      borderRadius: 10,
                      background: '#f4fafa',
                      padding: '12px 16px',
                    }}
                  >
                    <div style={{ fontWeight: 600, color: '#333', fontSize: 14 }}>
                      {getCategoryIcon(category)}
                      {category.name}
                    </div>
                    {category.rules && (
                      <div style={{ marginTop: 8 }}>
                        {parseRule(category.rules)}
                      </div>
                    )}
                  </div>
                ))}

                {/* Non-GP Categories (Rendered with collapse) */}
                {clinician.product_categories?.filter((category) => category.type !== 'gp').length > 0 && (
                  <Collapse
                    accordion
                    defaultActiveKey={['0']}
                    expandIconPosition="end"
                    style={{ background: 'transparent', border: 'none' }}
                  >
                    {clinician.product_categories?.filter((category) => category.type !== 'gp').map((category, catIdx) => (
                      <Panel
                        header={
                          <div style={{ fontWeight: 600, color: '#333', fontSize: 14 }}>
                            {getCategoryIcon(category)}
                            {category.name}
                          </div>
                        }
                        key={catIdx.toString()}
                        style={{
                          marginBottom: 12,
                          border: '1px solid #c8e6e6',
                          borderRadius: 10,
                          background: '#f4fafa',
                          overflow: 'hidden',
                        }}
                      >
                        <div style={{ padding: '0px 4px' }}>
                          {category.type === 'd2c' || category.type === 'corporate' ? (
                            <>
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '16px' }}>
                                {category.non_gp_products?.data?.length > 0 ? (
                                  category.non_gp_products.data.map((product, prodIdx) => (
                                    <div key={prodIdx} style={{ background: '#fff', padding: '8px 12px', border: '1px solid #e0f0f0', borderRadius: 6 }}>
                                      <Tag
                                        style={{
                                          borderColor: '#c8e6e6',
                                          color: '#444',
                                          background: '#e6f5f5',
                                          fontSize: 13,
                                          fontWeight: 500,
                                          padding: '2px 8px',
                                          marginBottom: 4,
                                        }}
                                      >
                                        {product.name}
                                      </Tag>

                                      <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                                        <BankOutlined style={{ marginRight: 4 }} />Clinic Mode: {product.rules?.clinic_mode === 'all' ? 'All Clinics' : 'Specific Clinics'}
                                      </div>
                                      {parseRule(product.rules)}
                                    </div>
                                  ))
                                ) : (
                                  <div style={{ fontSize: 12, color: '#888', marginLeft: 4 }}>Clinician Available for all {category.name}</div>
                                )}
                              </div>
                              {category.non_gp_products?.total > category.non_gp_products?.per_page && (
                                <div className="custom-pagination-wrapper" style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                  <Pagination
                                    current={category.non_gp_products.current_page}
                                    pageSize={category.non_gp_products.per_page}
                                    total={category.non_gp_products.total}
                                    onChange={(page) => handlePageChange(page, clinician.clinician_id || clinician.id, category.product_category_id || category.id)}
                                    showSizeChanger={false}
                                    itemRender={(page, type, originalElement) => {
                                      const isPrevDisabled = category.non_gp_products.current_page === 1;
                                      const isNextDisabled = category.non_gp_products.current_page === category.non_gp_products.last_page;
                                      if (type === 'prev') {
                                        return <span style={{ color: isPrevDisabled ? '#ccc' : '#666', fontSize: 14 }}>Previous</span>;
                                      }
                                      if (type === 'next') {
                                        return <span style={{ color: isNextDisabled ? '#ccc' : '#666', fontSize: 14 }}>Next</span>;
                                      }
                                      return originalElement;
                                    }}
                                  />
                                </div>
                              )}
                            </>
                          ) : (
                            <div>
                              <Tag
                                style={{
                                  borderColor: '#c8e6e6',
                                  color: '#444',
                                  background: '#fff',
                                  fontSize: 13,
                                  padding: '2px 8px',
                                }}
                              >
                                {category.name}
                              </Tag>
                            </div>
                          )}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>
                )}
              </div>
            </Panel>
          ))}
        </Collapse>
      )}

      <Divider
        style={{
          margin: 'auto',
          height: 25,
          borderColor: 'rgba(0, 131, 133, 1)',
        }}
      />

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
        <Button
          className="add-generic-btn"
          style={{ width: 100, height: 40 }}
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default LantumProductAvailability;
